<template>
  <Layout>
    <div class="container">
      <Settings></Settings>
    </div>
  </Layout>
</template>

<script setup lang="ts">
import Settings from "@/components/school/settings/Settings.vue";
import Layout from "./Layout.vue";

//
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
</style>
